module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Wand.10b093f5.png";